import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { FacilityService } from "../../../shared/services/facility.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { UserService } from "../../../shared";

@Component({
	templateUrl: "./visitorstoday.component.html",
})
export class VisitorsTodayComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private facilityService: FacilityService,
		private dialogService: DialogService,
		private userService: UserService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		FacilityID: 0,
		InFacilityID: "All",
		ShowPhotoID: "Yes",
		OrderByID: "Name",
		ImageLogo: "",
	};
	//Insert Custom Lists Here
	FacilityList: any = [];
	ImageLogoList: any = [];

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	InFacilityList = [
		//Insert Custom List Items Here
		{
			InFacilityID: "All",
			InFacilityName: "All",
		},
		{
			InFacilityID: "Yes",
			InFacilityName: "Yes",
		},
		{
			InFacilityID: "No",
			InFacilityName: "No",
		},
	];

	ShowPhotoList = [
		//Insert Custom List Items Here
		{
			ShowPhotoID: "Yes",
			ShowPhotoName: "Yes",
		},
		{
			ShowPhotoID: "No",
			ShowPhotoName: "No",
		},
	];

	OrderByList = [
		//Insert Custom List Items Here
		{
			OrderByID: "Name",
			OrderByName: "Name",
		},
		{
			OrderByID: "Comment",
			OrderByName: "Comment",
		},
		{
			OrderByID: "Company",
			OrderByName: "Company",
		},
		{
			OrderByID: "Destination",
			OrderByName: "Destination",
		},
		{
			OrderByID: "Entry Location",
			OrderByName: "Entry Location",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 391;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		//Insert Custom Init Methods Here
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}
	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(val) {
		this.report.SchoolID = val;

		this.loadFacilityList();
		this.loadLogolist();
	}

	private loadFacilityList() {
		this.report.FacilityID = 0;
		var result = this.facilityService.loadFacilityRPTList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.FacilityList = response;

				this.FacilityList.unshift({
					FacilityID: 0,
					FacilityName: "All Facilities",
				});
				this.report.FacilityID = this.FacilityList[0].FacilityID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.FacilityID) {
		// 	this.errorMessage = "Select the Facility"
		// 	return;
		// }

		// if (!this.report.InFacilityID) {
		// 	this.errorMessage = "Select the InFacility"
		// 	return;
		// }

		// if (!this.report.ShowPhotoID) {
		// 	this.errorMessage = "Select the ShowPhoto"
		// 	return;
		// }

		// if (!this.report.OrderByID) {
		// 	this.errorMessage = "Select the OrderBy"
		// 	return;
		// }

		// if (!this.report.UserID) {
		// 	this.errorMessage = "Select the User"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 391;

		var result = this.reportService.Print(reportID, strParam, 202, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: FacilityID
		strParam += this.report.FacilityID + "|FacilityID";

		//Parameter 2: InFacility
		strParam += "," + this.report.InFacilityID + "|InFacility";

		//Parameter 3: ShowPhoto
		strParam += "," + this.report.ShowPhotoID + "|ShowPhoto";

		//Parameter 4: OrderBy
		strParam += "," + this.report.OrderByID + "|OrderBy";

		//Parameter 5: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		//Parameter 6: UserID
		strParam += "," + this.user.userID + "|UserID";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
